module.exports = __webpack_public_path__ + "static/media/angle-right.a1bc289b.svg";